import ClosedRestaurantImage, { ClosedRestaurantImageProps } from './ClosedRestaurantImage';

export type { ClosedRestaurantImageProps };
export default ClosedRestaurantImage;
